<template>
    <form @submit.prevent="onSubmit">
        <v-row>
            <v-col cols="12">
                <v-text-field label="Nombre" v-model="localModal.nombre" />
            </v-col>


            <v-col cols="12">
                <v-select
                    :items="tratamientos"
                    item-text="nombre"
                    item-value="idtratamiento"
                    v-model="localModal.secuencia"
                    label="Tratamiento"
                    hide-details
                >
                    <!-- <template #append-outer>
                        <v-btn
                            icon
                            color="primary"
                            @click.stop="$emit('add:tratamiento')"
                            title="Agregar tratamiento"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template> -->
                    <template #item="{ item }">
                        <div class="py-3">
                            <strong>{{ item.nombre }}</strong>
                            <div class="text--secondary text-caption">
                                {{ reduceText(item.descripcion, 50) }}
                            </div>
                        </div>
                    </template>
                    <template #selection="{ item }">
                        <div class="py-3">
                            <strong>{{ item.nombre }}</strong>
                            <div class="text--secondary text-caption">
                                {{ reduceText(item.descripcion, 50) }}
                            </div>
                        </div>
                    </template>
                </v-select>
            </v-col>
         

            <!-- Imagen: type file -->
            <v-col cols="12">
                <div class="preview-img">
                    <v-img v-if="imagenPreview" :src="imagenPreview" height="150"  contain class="mb-2"/>
                    <v-img v-else-if="localModal.imagen" :src="assetAWS(localModal.imagen)" height="150" contain class="mb-2"/>
                </div>
                <v-file-input label="Imagen" accept="image/*" v-model="imagenFile" @change="filledFile($event, 'imagen')" />
            </v-col>
    
            <v-col cols="12">
                <v-switch
                    v-model="localModal.estado"
                    label="Estado"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>

            <v-col cols="12" class="btns-form">
                <v-btn text @click="cancel" :disabled="loading">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancelar
                </v-btn>
                <v-btn type="submit" color="primary" :disabled="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    Guardar
                </v-btn>
            </v-col>

        </v-row>
    </form>
</template>

<script>
    import { tratamientoColor } from '@/models/tratamientoColor';

    export default {
        name: 'FormTratamientoColor',
        props: {
            value: {
                type: Object,
                default: () => ({
                    ...tratamientoColor
                }),
            },
            loading: {
                type: Boolean,
                default: false,
            },
            tratamientos: {
                type: Array,
                default: () => [],
            }
        },
        emits: ['input','submit', 'cancel'],
        watch: {
            value(newVal) {
                if (this.sync) return;
                this.sync = true;
                this.localModal = {...newVal};

                this.imagenFile = null;
                this.imagenPreview = null;

                this.$nextTick(() => {
                    this.sync = false;
                });
            },
            localModal(newVal) {
                if (this.sync) return;
                this.sync = true;
                this.$emit('input', newVal);
                this.$nextTick(() => {
                    this.sync = false;
                });
            }
        },
        data() {
            return {
                sync : false,
                localModal: { ...this.value},
                imagenFile: null,
                imagenPreview: null,
            };
        },
        methods: {
            onSubmit() {
                this.$emit('submit', {
                    ...this.localModal,
                    imagen_file: this.imagenFile,
                });
            },
            generatePreview(file, input) {
                if (!file) {
                    this[input] = null;
                    return;
                }
               
                const reader = new FileReader();
                reader.onload = (e) => {
                    this[input] = e.target.result || null;
                };

                reader.readAsDataURL(file);
            },
            filledFile(file, type){
                if (type == 'imagen') {
                    this.generatePreview(file, 'imagenPreview');
                }
            },

            cancel() {
                this.$emit('cancel');
            }
            
        }
    };

</script>

<style scoped>
    .btns-form {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }

    .preview-img {
        display: grid;
        place-items: center;
        background: rgba(255, 255, 255,.5);
        margin-bottom: .5rem;
    }

</style>